import { useCallback, useEffect, useState } from 'react';
import { href, parseRoute, type Route } from './router';

/**
 * History APIだけで戻る/進む・直接アクセスを扱う。
 * URL生成はrouter.hrefに一元化しているので、ここではpush/replaceの使い分けだけを持つ。
 */
export function useRoute(): {
  route: Route;
  navigate(next: Route, options?: { replace?: boolean }): void;
} {
  const [route, setRoute] = useState<Route>(() => parseRoute(currentUrl()));

  useEffect(() => {
    const onPopState = () => setRoute(parseRoute(currentUrl()));
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const navigate = useCallback((next: Route, options?: { replace?: boolean }) => {
    const url = href(next);
    // 同じURLへのpushで履歴を増やさない。選択状態の更新はreplaceで行うため。
    if (url === currentUrl()) {
      setRoute(parseRoute(url));
      return;
    }
    if (options?.replace) window.history.replaceState(null, '', url);
    else window.history.pushState(null, '', url);
    setRoute(parseRoute(url));
  }, []);

  return { route, navigate };
}

function currentUrl(): string {
  return `${window.location.pathname}${window.location.search}`;
}
